import { inFreezing } from 'core/common/utils/date'

export const SHELL_LISTENER_LOGOUT_KEY = 'shell:logout'

export const CSS_PREFIX = 'MaasProduct'

export const PER_PAGE_OPTIONS = [10, 25, 50]
export const PER_PAGE_VALUE_INITIAL = PER_PAGE_OPTIONS[0]
export const PER_PAGE_MAX_VALUE = PER_PAGE_OPTIONS[2]

export const SORT_BY_VALUE_INITIAL = ''

export const SEARCH_DELAY = 500
export const SEARCH_MIN_LETTERS_REQUIRED = 2

export const SUPPORT_TICKETS_URL = 'https://suporte.integracommerce.com.br/support/tickets'
export const MARKETPLACE_INTEGRA_URL = 'https://marketplace.integracommerce.com.br'

export const ALLOWED_UPLOAD_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp']
export const ALLOWED_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/webp']

export const IN_FREEZING = inFreezing('2023-11-22T00:00:00', '2023-11-27T09:00:00')

export const ALERTS_REQUEST_TIMEOUT = 8000

export const ALLOWED_ATTRIBUTES_MAGALU = [
  { label: 'Adicional', value: 'additional' },
  { label: 'Capacidade', value: 'capacity' },
  { label: 'Cápsula', value: 'capsule' },
  { label: 'Console', value: 'console' },
  { label: 'Cor', value: 'color' },
  { label: 'Lado', value: 'side' },
  { label: 'Operador', value: 'operator' },
  { label: 'Peça', value: 'piece' },
  { label: 'Polegada', value: 'inch' },
  { label: 'Quantidade', value: 'quantity' },
  { label: 'Sabor', value: 'flavor' },
  { label: 'Tamanho', value: 'size' },
  { label: 'Voltagem', value: 'voltage' },
  { label: 'Volume', value: 'volume' },
]

export const ALLOWED_SORT_BY_PORTFOLIO = [
  { label: 'Título (a-z)', value: 'name' },
  { label: 'Título (z-a)', value: '-name' },
  { label: 'Menor preço', value: 'price' },
  { label: 'Maior preço', value: '-price' },
  { label: 'Atualização antiga', value: 'updated_at' },
  { label: 'Atualização recente', value: '-updated_at' },
]

export const ELASTIC_ALLOWED_SORT_BY_PORTFOLIO = [
  { label: 'Título (a-z)', value: 'title:asc' },
  { label: 'Título (z-a)', value: 'title:desc' },
  { label: 'Menor preço', value: 'sell_price:asc' },
  { label: 'Maior preço', value: 'sell_price:desc' },
  { label: 'Atualização antiga', value: 'updated_at:asc' },
  { label: 'Atualização recente', value: 'updated_at:desc' },
]

export const ALLOWED_FILTER_FIND_PRODUCT = [
  { label: 'Título', value: 'name' },
  { label: 'SKU', value: 'sku' },
  { label: 'EAN', value: 'ean' },
  { label: 'ISBN', value: 'isbn' },
  { label: 'Agrupador', value: 'agrupador' },
]

export const ELASTIC_ALLOWED_FILTER_FIND_PRODUCT = [
  { label: 'Título', value: 'title' },
  { label: 'SKU', value: 'sku' },
  { label: 'EAN', value: 'ean' },
  { label: 'ISBN', value: 'isbn' },
  { label: 'Agrupador', value: 'agrupador' },
]

export const POPUP_ANCHOR_RIGHT_CONFIG = {
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'right',
  },
} as const

export enum EInternalStatus {
  INTERNAL = 'internal',
  FORBIDDEN = 'forbidden',
}
